import { gsap } from "gsap";
import { defaultFadeFromToOptions, defaultFadeToOptions } from "./fade.config";
import { type FadeOptions } from "./fade.types";

export function fadeFromTo(
  element: Element | HTMLElement | Array<HTMLElement> | Array<Element>,
  options: Partial<FadeOptions> = {},
): gsap.core.Tween {
  const { from, to, duration, autoAlpha, clearProps, delay, stagger, ease } = {
    ...defaultFadeFromToOptions,
    ...options,
  };
  return gsap.fromTo(
    element,
    {
      [autoAlpha ? "autoAlpha" : "opacity"]: from ?? 0,
      pointerEvents: from === 0 ? "none" : "",
    },
    {
      delay,
      duration,
      ease,
      stagger,
      [autoAlpha ? "autoAlpha" : "opacity"]: to,
      clearProps: clearProps
        ? "opacity,visibility,pointerEvents"
        : "pointerEvents",
    },
  );
}

export function fadeTo(
  element: Element | HTMLElement | Array<HTMLElement> | Array<Element>,
  options: Partial<FadeOptions> = {},
): gsap.core.Tween {
  const { to, duration, autoAlpha, clearProps, delay, stagger, ease } = {
    ...defaultFadeToOptions,
    ...options,
  };
  return gsap.to(element, {
    delay,
    duration,
    ease,
    stagger,
    [autoAlpha ? "autoAlpha" : "opacity"]: to,
    clearProps: clearProps ? "opacity,visibility" : "",
  });
}
